import { TestIds } from './payrun-approvers.test-helpers';
import * as S from './payrun-approvers-list.styles';
import { PayrunScheduleNavigatorProps } from './payrun-approvers-list.types';

export const PayScheduleNavigator = (props: Readonly<PayrunScheduleNavigatorProps>) => {
  const { paySchedules } = props;
  const totalPaySchedules = paySchedules.length;

  const openLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();
    window.open(event.currentTarget.href, '_blank', 'noopener,noreferrer');
  };

  if (totalPaySchedules === 0) {
    return '-';
  }
  const displayedSchedules = paySchedules.slice(0, 2);
  const remainingCount = totalPaySchedules - 2;
  return (
    <S.PayScheduleContainer data-testid={TestIds.PayScheduleNavigator}>
      {displayedSchedules.map((payschedule) => (
        <S.PayScheduleNav
          key={payschedule.id}
          to={`/payschedule/${payschedule.id}`}
          onClick={openLink}
        >
          {payschedule.name}
        </S.PayScheduleNav>
      ))}
      {remainingCount > 0 && (
        <S.PayScheduleDetailNav data-testid={TestIds.PayScheduleNavigatorCount}>
          +{remainingCount}
        </S.PayScheduleDetailNav>
      )}
    </S.PayScheduleContainer>
  );
};
